import React from "react";
import classNames from "classnames/bind";
import s from "./AboutMe.module.scss";
import MailIcon from "@material-ui/icons/Mail";
import PhoneIphoneIcon from "@material-ui/icons/PhoneIphone";
import GitHubIcon from "@material-ui/icons/GitHub";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import LanguageIcon from "@material-ui/icons/Language";
import avatar from "../../static/images/profilePic.jpg";
import { Box, Button, Avatar, SvgIcon } from "@material-ui/core";
import { getMakeStyleClasses } from "../common/getMakeStyleClasses";
import { ABOUT_ME } from "../../constants/constants";

const AboutMe = (props) => {
  const classes = getMakeStyleClasses(compClasses);
  const cx = classNames.bind(classes);
  const {
    name,
    designation,
    description,
    iconData,
    avatarSrc,
    showImage = "yes",
  } = props.data[0];
  return (
    <Box
      className={cx(s.aboutMeContainer, classes.secondaryTextColor, {
        [s.vertical]: props.templateStyle === "vertical",
        [s.colourTemplate]: props.templateStyle === "colour-template",
      })}
    >
      <section className={s.aboutMeDetails}>
        <section className={s.flexRow}>
          {String(showImage).toLowerCase() === "yes" && (
            <Avatar
              alt={name}
              src={avatarSrc || avatar}
              className={cx(classes.large, s.avatar)}
            />
          )}
          <section className={s.headingContainer}>
            <div className={cx(classes.primaryThemeColor, s.sectionHeading)}>
              {name}
            </div>
            <div className={cx(classes.primaryThemeColor, s.sectionSubHeading)}>
              {designation}
            </div>
          </section>
        </section>
        <div className={s.description}>{description}</div>
      </section>
      <Box className={s.iconDetailContainer}>
        {iconData.map((x, index) => (
          <Button
            key={index}
            size="small"
            disabled={!x.link}
            className={cx(classes.secondaryTextColor, s.iconButton)}
            endIcon={
              !["vertical", "colour-template"].includes(props.templateStyle) &&
              getIcon(classes)(x.type)
            }
            startIcon={
              ["vertical", "colour-template"].includes(props.templateStyle) &&
              getIcon(classes)(x.type)
            }
            onClick={() => window.open(x.link, "_blank")}
          >
            {x.title}
          </Button>
        ))}
      </Box>
    </Box>
  );
};

const compClasses = (theme) => ({
  large: {
    height: "60px",
    width: "60px",
    border: `2px solid ${theme.palette.primary.main}`,
  },
  iconDetailOverride: {
    height: "0.7em",
    width: "0.7em",
  },
});

const typeMap = (classes) => ({
  [ABOUT_ME.ICON_DETAILS.MAIL]: (
    <MailIcon className={classes.iconDetailOverride} />
  ),
  [ABOUT_ME.ICON_DETAILS.MOBILE]: (
    <PhoneIphoneIcon className={classes.iconDetailOverride} />
  ),
  [ABOUT_ME.ICON_DETAILS.LINKEDIN]: (
    <LinkedInIcon className={classes.iconDetailOverride} />
  ),
  [ABOUT_ME.ICON_DETAILS.GITHUB]: (
    <GitHubIcon className={classes.iconDetailOverride} />
  ),
  [ABOUT_ME.ICON_DETAILS.WEBSITE]: (
    <LanguageIcon className={classes.iconDetailOverride} />
  ),
  [ABOUT_ME.ICON_DETAILS.TWITTER]: (
    <Twitter fontSize="small" className={classes.iconDetailOverride} />
  ),
});

function Twitter(props) {
  return (
    <SvgIcon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 26 26"
        width="26px"
        height="26px"
      >
        <path d="M 25.855469 5.574219 C 24.914063 5.992188 23.902344 6.273438 22.839844 6.402344 C 23.921875 5.75 24.757813 4.722656 25.148438 3.496094 C 24.132813 4.097656 23.007813 4.535156 21.8125 4.769531 C 20.855469 3.75 19.492188 3.113281 17.980469 3.113281 C 15.082031 3.113281 12.730469 5.464844 12.730469 8.363281 C 12.730469 8.773438 12.777344 9.175781 12.867188 9.558594 C 8.503906 9.339844 4.636719 7.246094 2.046875 4.070313 C 1.59375 4.847656 1.335938 5.75 1.335938 6.714844 C 1.335938 8.535156 2.261719 10.140625 3.671875 11.082031 C 2.808594 11.054688 2 10.820313 1.292969 10.425781 C 1.292969 10.449219 1.292969 10.46875 1.292969 10.492188 C 1.292969 13.035156 3.101563 15.15625 5.503906 15.640625 C 5.0625 15.761719 4.601563 15.824219 4.121094 15.824219 C 3.78125 15.824219 3.453125 15.792969 3.132813 15.730469 C 3.800781 17.8125 5.738281 19.335938 8.035156 19.375 C 6.242188 20.785156 3.976563 21.621094 1.515625 21.621094 C 1.089844 21.621094 0.675781 21.597656 0.265625 21.550781 C 2.585938 23.039063 5.347656 23.90625 8.3125 23.90625 C 17.96875 23.90625 23.25 15.90625 23.25 8.972656 C 23.25 8.742188 23.246094 8.515625 23.234375 8.289063 C 24.261719 7.554688 25.152344 6.628906 25.855469 5.574219" />
      </svg>
    </SvgIcon>
  );
}

const getIcon = (classes) => (type) => {
  return typeMap(classes)[type];
};

export default AboutMe;
